import { Reveal } from "@/components/motion";
import ServiceAccordion from "@/components/ServiceAccordion";

export default function Services() {
  return (
    <section className="bg-ink text-white sec" data-testid="services-section">
      <div className="wrap">
        <Reveal>
          <p className="eyebrow text-gold flex items-center gap-3 mb-6">
            What we do <span className="hidden sm:block h-px w-14 bg-gold/60" />
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="h-display font-bold text-[32px] sm:text-5xl lg:text-[56px] leading-[1.06] mb-14">
            ESG & Sustainability expertise. Practical outcomes.
          </h2>
        </Reveal>
        <ServiceAccordion />
      </div>
    </section>
  );
}
